/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum Province {
  GAUTENG = "GAUTENG",
  KWAZULU_NATAL = "KWAZULU_NATAL",
  MPUMALANGA = "MPUMALANGA",
  WESTERN_CAPE = "WESTERN_CAPE",
  LIMPOPO = "LIMPOPO",
  EASTERN_CAPE = "EASTERN_CAPE",
  NORTH_WEST = "NORTH_WEST",
  FREE_STATE = "FREE_STATE",
  NORTHERN_CAPE = "NORTHERN_CAPE",
}


export enum UserRole {
  ROOTS_SUPER_ADMIN = "ROOTS_SUPER_ADMIN",
  ROOTS_ADMIN = "ROOTS_ADMIN",
  CONSUMER_ADMIN = "CONSUMER_ADMIN",
  SUPER_USER = "SUPER_USER",
  USER = "USER",
}


export enum UserStatus {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}


export enum Industry {
  INDUSTRY_ONE = "INDUSTRY_ONE",
  INDUSTRY_TWO = "INDUSTRY_TWO",
  INDUSTRY_THREE = "INDUSTRY_THREE",
}


export type ModelCompanyFilterInput = {
  id?: ModelIDFilterInput | null,
  createdAt?: ModelStringFilterInput | null,
  name?: ModelStringFilterInput | null,
  emailAddress?: ModelStringFilterInput | null,
  contactNumber?: ModelStringFilterInput | null,
  address?: ModelStringFilterInput | null,
  province?: ModelProvinceFilterInput | null,
  industry?: ModelIndustryFilterInput | null,
  physicalAddress?: ModelStringFilterInput | null,
  numberOfEmployees?: ModelStringFilterInput | null,
  archived?: ModelBooleanFilterInput | null,
  suburb?: ModelSuburbFilterInput | null,
  and?: Array< ModelCompanyFilterInput | null > | null,
  or?: Array< ModelCompanyFilterInput | null > | null,
  not?: ModelCompanyFilterInput | null,
};

export type ModelIDFilterInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelStringFilterInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelProvinceFilterInput = {
  eq?: Province | null,
  ne?: Province | null,
};

export type ModelIndustryFilterInput = {
  eq?: Industry | null,
  ne?: Industry | null,
};

export type ModelBooleanFilterInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSuburbFilterInput = {
  eq?: Suburb | null,
  ne?: Suburb | null,
};

export enum Suburb {
  SUBURB_ONE = "SUBURB_ONE",
  SUBURB_TWO = "SUBURB_TWO",
  SUBURB_THREE = "SUBURB_THREE",
}


export type ModelReportFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  description?: ModelStringFilterInput | null,
  publisedDate?: ModelStringFilterInput | null,
  price?: ModelStringFilterInput | null,
  documentLocation?: ModelStringFilterInput | null,
  maxDownloads?: ModelStringFilterInput | null,
  downloadable?: ModelBooleanFilterInput | null,
  status?: ModelReportStatusFilterInput | null,
  province?: ModelProvinceFilterInput | null,
  suburb?: ModelSuburbFilterInput | null,
  city?: ModelStringFilterInput | null,
  paidOrFree?: ModelBooleanFilterInput | null,
  reportDetails?: ModelStringFilterInput | null,
  coverImageUrl?: ModelStringFilterInput | null,
  documentResourceUrl?: ModelStringFilterInput | null,
  and?: Array< ModelReportFilterInput | null > | null,
  or?: Array< ModelReportFilterInput | null > | null,
  not?: ModelReportFilterInput | null,
};

export type ModelReportStatusFilterInput = {
  eq?: ReportStatus | null,
  ne?: ReportStatus | null,
};

export enum ReportStatus {
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
}


export type ModelTransactionFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
};

export type ModelCategoryFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  and?: Array< ModelCategoryFilterInput | null > | null,
  or?: Array< ModelCategoryFilterInput | null > | null,
  not?: ModelCategoryFilterInput | null,
};

export type ModelTagFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  and?: Array< ModelTagFilterInput | null > | null,
  or?: Array< ModelTagFilterInput | null > | null,
  not?: ModelTagFilterInput | null,
};

export type ModelInterestFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  and?: Array< ModelInterestFilterInput | null > | null,
  or?: Array< ModelInterestFilterInput | null > | null,
  not?: ModelInterestFilterInput | null,
};

export type CreateTaskInput = {
  id?: string | null,
  title: string,
  description?: string | null,
  status?: string | null,
};

export type UpdateTaskInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  status?: string | null,
};

export type DeleteTaskInput = {
  id?: string | null,
};

export type CreateCompanyInput = {
  id?: string | null,
  createdAt: string,
  name?: string | null,
  emailAddress?: string | null,
  contactNumber?: string | null,
  address?: string | null,
  province?: Province | null,
  industry?: Industry | null,
  physicalAddress?: string | null,
  numberOfEmployees?: string | null,
  archived?: boolean | null,
  suburb?: Suburb | null,
  companyTeamLeadId?: string | null,
  companyTransactionsId?: string | null,
};

export enum CardType {
  VISA = "VISA",
  MASTER_CARD = "MASTER_CARD",
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
}


export type UpdateCompanyInput = {
  id: string,
  createdAt?: string | null,
  name?: string | null,
  emailAddress?: string | null,
  contactNumber?: string | null,
  address?: string | null,
  province?: Province | null,
  industry?: Industry | null,
  physicalAddress?: string | null,
  numberOfEmployees?: string | null,
  archived?: boolean | null,
  suburb?: Suburb | null,
  companyTeamLeadId?: string | null,
  companyTransactionsId?: string | null,
};

export type DeleteCompanyInput = {
  id?: string | null,
};

export type CreateUserInput = {
  id?: string | null,
  dateOfBirth?: string | null,
  name?: string | null,
  surname?: string | null,
  emailAddress?: string | null,
  contactNumber?: string | null,
  idNumber?: string | null,
  physicalAddress?: string | null,
  archived?: boolean | null,
  verified?: boolean | null,
  role?: UserRole | null,
  status?: UserStatus | null,
  jobTitle?: string | null,
  userCompanyTeamLeadId?: string | null,
};

export type UpdateUserInput = {
  id: string,
  dateOfBirth?: string | null,
  name?: string | null,
  surname?: string | null,
  emailAddress?: string | null,
  contactNumber?: string | null,
  idNumber?: string | null,
  physicalAddress?: string | null,
  archived?: boolean | null,
  verified?: boolean | null,
  role?: UserRole | null,
  status?: UserStatus | null,
  jobTitle?: string | null,
  userCompanyTeamLeadId?: string | null,
};

export type DeleteUserInput = {
  id?: string | null,
};

export type CreateReportInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  publisedDate?: string | null,
  price?: string | null,
  documentLocation?: string | null,
  maxDownloads?: string | null,
  downloadable?: boolean | null,
  status?: ReportStatus | null,
  province?: Province | null,
  suburb?: Suburb | null,
  city?: string | null,
  paidOrFree?: boolean | null,
  reportDetails?: string | null,
  coverImageUrl?: string | null,
  documentResourceUrl?: string | null,
  reportTransactionsId?: string | null,
};

export type UpdateReportInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  publisedDate?: string | null,
  price?: string | null,
  documentLocation?: string | null,
  maxDownloads?: string | null,
  downloadable?: boolean | null,
  status?: ReportStatus | null,
  province?: Province | null,
  suburb?: Suburb | null,
  city?: string | null,
  paidOrFree?: boolean | null,
  reportDetails?: string | null,
  coverImageUrl?: string | null,
  documentResourceUrl?: string | null,
  reportTransactionsId?: string | null,
};

export type DeleteReportInput = {
  id?: string | null,
};

export type CreateReigonInput = {
  id?: string | null,
  name?: string | null,
};

export type UpdateReigonInput = {
  id: string,
  name?: string | null,
};

export type DeleteReigonInput = {
  id?: string | null,
};

export type CreateTagInput = {
  id?: string | null,
  name?: string | null,
};

export type UpdateTagInput = {
  id: string,
  name?: string | null,
};

export type DeleteTagInput = {
  id?: string | null,
};

export type CreateCategoryInput = {
  id?: string | null,
  name?: string | null,
};

export type UpdateCategoryInput = {
  id: string,
  name?: string | null,
};

export type DeleteCategoryInput = {
  id?: string | null,
};

export type CreateVoucherInput = {
  id?: string | null,
  name?: string | null,
  code?: string | null,
  discountPercentage?: string | null,
};

export type UpdateVoucherInput = {
  id: string,
  name?: string | null,
  code?: string | null,
  discountPercentage?: string | null,
};

export type DeleteVoucherInput = {
  id?: string | null,
};

export type CreateFaqInput = {
  id?: string | null,
  title?: string | null,
  question?: string | null,
  answer?: string | null,
  topic?: FaqTopic | null,
  category?: FaqCategory | null,
};

export enum FaqTopic {
  TOPIC_ONE = "TOPIC_ONE",
  TOPIC_TWO = "TOPIC_TWO",
  TOPIC_THREE = "TOPIC_THREE",
}


export enum FaqCategory {
  CATEGORY_ONE = "CATEGORY_ONE",
  CATEGORY_TWO = "CATEGORY_TWO",
  CATEGORY_THREE = "CATEGORY_THREE",
}


export type UpdateFaqInput = {
  id: string,
  title?: string | null,
  question?: string | null,
  answer?: string | null,
  topic?: FaqTopic | null,
  category?: FaqCategory | null,
};

export type DeleteFaqInput = {
  id?: string | null,
};

export type CreateInterestInput = {
  id?: string | null,
  name?: string | null,
};

export type UpdateInterestInput = {
  id: string,
  name?: string | null,
};

export type DeleteInterestInput = {
  id?: string | null,
};

export type CreateTransactionInput = {
  id?: string | null,
  transactionCardId: string,
  transactionReportId: string,
  transactionCompanyId: string,
};

export type UpdateTransactionInput = {
  id: string,
  transactionCardId?: string | null,
  transactionReportId?: string | null,
  transactionCompanyId?: string | null,
};

export type DeleteTransactionInput = {
  id?: string | null,
};

export type CreateCardInput = {
  id?: string | null,
  name?: string | null,
  type?: CardType | null,
  number?: string | null,
  nameOnCard?: string | null,
  expiryDate?: string | null,
  ccv?: string | null,
  cardPurchasesId: string,
};

export type UpdateCardInput = {
  id: string,
  name?: string | null,
  type?: CardType | null,
  number?: string | null,
  nameOnCard?: string | null,
  expiryDate?: string | null,
  ccv?: string | null,
  cardPurchasesId?: string | null,
};

export type DeleteCardInput = {
  id?: string | null,
};

export type CreateCompanyInterestInput = {
  id?: string | null,
  companyInterestCompanyId?: string | null,
  companyInterestInterestsId?: string | null,
};

export type UpdateCompanyInterestInput = {
  id: string,
  companyInterestCompanyId?: string | null,
  companyInterestInterestsId?: string | null,
};

export type DeleteCompanyInterestInput = {
  id?: string | null,
};

export type CreateUserCompanyInput = {
  id?: string | null,
  userCompanyCompanyId?: string | null,
  userCompanyUserId?: string | null,
};

export type UpdateUserCompanyInput = {
  id: string,
  userCompanyCompanyId?: string | null,
  userCompanyUserId?: string | null,
};

export type DeleteUserCompanyInput = {
  id?: string | null,
};

export type CreateCompanyReportInput = {
  id?: string | null,
  companyReportReportId?: string | null,
  companyReportCompanyId?: string | null,
};

export type UpdateCompanyReportInput = {
  id: string,
  companyReportReportId?: string | null,
  companyReportCompanyId?: string | null,
};

export type DeleteCompanyReportInput = {
  id?: string | null,
};

export type CreateReportTagInput = {
  id?: string | null,
  reportTagTagId?: string | null,
  reportTagReportId?: string | null,
};

export type UpdateReportTagInput = {
  id: string,
  reportTagTagId?: string | null,
  reportTagReportId?: string | null,
};

export type DeleteReportTagInput = {
  id?: string | null,
};

export type CreateReportCategoryInput = {
  id?: string | null,
  reportCategoryCategoryId?: string | null,
  reportCategoryReportId?: string | null,
};

export type UpdateReportCategoryInput = {
  id: string,
  reportCategoryCategoryId?: string | null,
  reportCategoryReportId?: string | null,
};

export type DeleteReportCategoryInput = {
  id?: string | null,
};

export type CreateReportReigonInput = {
  id?: string | null,
  reportReigonReigonId?: string | null,
  reportReigonReportId?: string | null,
};

export type UpdateReportReigonInput = {
  id: string,
  reportReigonReigonId?: string | null,
  reportReigonReportId?: string | null,
};

export type DeleteReportReigonInput = {
  id?: string | null,
};

export type CreateReportVoucherInput = {
  id?: string | null,
  reportVoucherVoucherId?: string | null,
  reportVoucherReportId?: string | null,
};

export type UpdateReportVoucherInput = {
  id: string,
  reportVoucherVoucherId?: string | null,
  reportVoucherReportId?: string | null,
};

export type DeleteReportVoucherInput = {
  id?: string | null,
};

export type ModelTaskFilterInput = {
  id?: ModelIDFilterInput | null,
  title?: ModelStringFilterInput | null,
  description?: ModelStringFilterInput | null,
  status?: ModelStringFilterInput | null,
  and?: Array< ModelTaskFilterInput | null > | null,
  or?: Array< ModelTaskFilterInput | null > | null,
  not?: ModelTaskFilterInput | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDFilterInput | null,
  dateOfBirth?: ModelStringFilterInput | null,
  name?: ModelStringFilterInput | null,
  surname?: ModelStringFilterInput | null,
  emailAddress?: ModelStringFilterInput | null,
  contactNumber?: ModelStringFilterInput | null,
  idNumber?: ModelStringFilterInput | null,
  physicalAddress?: ModelStringFilterInput | null,
  archived?: ModelBooleanFilterInput | null,
  verified?: ModelBooleanFilterInput | null,
  role?: ModelUserRoleFilterInput | null,
  status?: ModelUserStatusFilterInput | null,
  jobTitle?: ModelStringFilterInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserRoleFilterInput = {
  eq?: UserRole | null,
  ne?: UserRole | null,
};

export type ModelUserStatusFilterInput = {
  eq?: UserStatus | null,
  ne?: UserStatus | null,
};

export type ModelReigonFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  and?: Array< ModelReigonFilterInput | null > | null,
  or?: Array< ModelReigonFilterInput | null > | null,
  not?: ModelReigonFilterInput | null,
};

export type ModelVoucherFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  code?: ModelStringFilterInput | null,
  discountPercentage?: ModelStringFilterInput | null,
  and?: Array< ModelVoucherFilterInput | null > | null,
  or?: Array< ModelVoucherFilterInput | null > | null,
  not?: ModelVoucherFilterInput | null,
};

export type ModelFaqFilterInput = {
  id?: ModelIDFilterInput | null,
  title?: ModelStringFilterInput | null,
  question?: ModelStringFilterInput | null,
  answer?: ModelStringFilterInput | null,
  topic?: ModelFaqTopicFilterInput | null,
  category?: ModelFaqCategoryFilterInput | null,
  and?: Array< ModelFaqFilterInput | null > | null,
  or?: Array< ModelFaqFilterInput | null > | null,
  not?: ModelFaqFilterInput | null,
};

export type ModelFaqTopicFilterInput = {
  eq?: FaqTopic | null,
  ne?: FaqTopic | null,
};

export type ModelFaqCategoryFilterInput = {
  eq?: FaqCategory | null,
  ne?: FaqCategory | null,
};

export type ModelCardFilterInput = {
  id?: ModelIDFilterInput | null,
  name?: ModelStringFilterInput | null,
  type?: ModelCardTypeFilterInput | null,
  number?: ModelStringFilterInput | null,
  nameOnCard?: ModelStringFilterInput | null,
  expiryDate?: ModelStringFilterInput | null,
  ccv?: ModelStringFilterInput | null,
  and?: Array< ModelCardFilterInput | null > | null,
  or?: Array< ModelCardFilterInput | null > | null,
  not?: ModelCardFilterInput | null,
};

export type ModelCardTypeFilterInput = {
  eq?: CardType | null,
  ne?: CardType | null,
};

export type ModelCompanyInterestFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelCompanyInterestFilterInput | null > | null,
  or?: Array< ModelCompanyInterestFilterInput | null > | null,
  not?: ModelCompanyInterestFilterInput | null,
};

export type ModelUserCompanyFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelUserCompanyFilterInput | null > | null,
  or?: Array< ModelUserCompanyFilterInput | null > | null,
  not?: ModelUserCompanyFilterInput | null,
};

export type ModelCompanyReportFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelCompanyReportFilterInput | null > | null,
  or?: Array< ModelCompanyReportFilterInput | null > | null,
  not?: ModelCompanyReportFilterInput | null,
};

export type ModelReportTagFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelReportTagFilterInput | null > | null,
  or?: Array< ModelReportTagFilterInput | null > | null,
  not?: ModelReportTagFilterInput | null,
};

export type ModelReportCategoryFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelReportCategoryFilterInput | null > | null,
  or?: Array< ModelReportCategoryFilterInput | null > | null,
  not?: ModelReportCategoryFilterInput | null,
};

export type ModelReportReigonFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelReportReigonFilterInput | null > | null,
  or?: Array< ModelReportReigonFilterInput | null > | null,
  not?: ModelReportReigonFilterInput | null,
};

export type ModelReportVoucherFilterInput = {
  id?: ModelIDFilterInput | null,
  and?: Array< ModelReportVoucherFilterInput | null > | null,
  or?: Array< ModelReportVoucherFilterInput | null > | null,
  not?: ModelReportVoucherFilterInput | null,
};

export type GetCompaniesUsersQueryVariables = {
  id: string,
};

export type GetCompaniesUsersQuery = {
  getCompany:  {
    __typename: "Company",
    id: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
        user:  {
          __typename: "User",
          id: string,
          dateOfBirth: string | null,
          name: string | null,
          surname: string | null,
          emailAddress: string | null,
          contactNumber: string | null,
          idNumber: string | null,
          physicalAddress: string | null,
          archived: boolean | null,
          verified: boolean | null,
          role: UserRole | null,
          status: UserStatus | null,
          jobTitle: string | null,
        } | null,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type GetUsersCompanyQueryVariables = {
  id: string,
};

export type GetUsersCompanyQuery = {
  getUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
        company:  {
          __typename: "Company",
          id: string,
          name: string | null,
          emailAddress: string | null,
          contactNumber: string | null,
          address: string | null,
          province: Province | null,
          physicalAddress: string | null,
          numberOfEmployees: string | null,
          industry: Industry | null,
          teamMembers:  {
            __typename: "ModelUserCompanyConnection",
            items:  Array< {
              __typename: "UserCompany",
              id: string,
              user:  {
                __typename: "User",
                id: string,
                dateOfBirth: string | null,
                name: string | null,
                surname: string | null,
                emailAddress: string | null,
                contactNumber: string | null,
                idNumber: string | null,
                physicalAddress: string | null,
                archived: boolean | null,
                verified: boolean | null,
                role: UserRole | null,
                status: UserStatus | null,
                jobTitle: string | null,
              } | null,
            } | null > | null,
            nextToken: string | null,
          } | null,
        } | null,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CountQueryVariables = {
  companyFilter?: ModelCompanyFilterInput | null,
  reportFilter?: ModelReportFilterInput | null,
  transFilter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CountQuery = {
  listCompanys:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
    } | null > | null,
    nextToken: string | null,
  } | null,
  listReports:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
    } | null > | null,
    nextToken: string | null,
  } | null,
  listTransactions:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      report:  {
        __typename: "Report",
        id: string,
      },
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetUserListQueryVariables = {
  id: string,
};

export type GetUserListQuery = {
  getUser:  {
    __typename: "User",
    id: string,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
        company:  {
          __typename: "Company",
          id: string,
          transactions:  {
            __typename: "Transaction",
            id: string,
            card:  {
              __typename: "Card",
              id: string,
            },
            report:  {
              __typename: "Report",
              id: string,
              name: string | null,
              publisedDate: string | null,
              price: string | null,
              maxDownloads: string | null,
              downloadable: boolean | null,
              city: string | null,
              coverImageUrl: string | null,
            },
          } | null,
        } | null,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type GetCategorysListQueryVariables = {
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCategorysListQuery = {
  listCategorys:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        items:  Array< {
          __typename: "ReportCategory",
          id: string,
        } | null > | null,
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetTagsListQueryVariables = {
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetTagsListQuery = {
  listTags:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        items:  Array< {
          __typename: "ReportTag",
          id: string,
        } | null > | null,
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetInterestsListQueryVariables = {
  filter?: ModelInterestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetInterestsListQuery = {
  listInterests:  {
    __typename: "ModelInterestConnection",
    items:  Array< {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        items:  Array< {
          __typename: "CompanyInterest",
          id: string,
        } | null > | null,
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportsListQueryVariables = {
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetReportsListQuery = {
  listReports:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        items:  Array< {
          __typename: "ReportCategory",
          id: string,
          category:  {
            __typename: "Category",
            id: string,
            name: string | null,
          } | null,
        } | null > | null,
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type CreateTaskMutationVariables = {
  input: CreateTaskInput,
};

export type CreateTaskMutation = {
  createTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateTaskMutationVariables = {
  input: UpdateTaskInput,
};

export type UpdateTaskMutation = {
  updateTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteTaskMutationVariables = {
  input: DeleteTaskInput,
};

export type DeleteTaskMutation = {
  deleteTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCompanyMutationVariables = {
  input: CreateCompanyInput,
};

export type CreateCompanyMutation = {
  createCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type UpdateCompanyMutationVariables = {
  input: UpdateCompanyInput,
};

export type UpdateCompanyMutation = {
  updateCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type DeleteCompanyMutationVariables = {
  input: DeleteCompanyInput,
};

export type DeleteCompanyMutation = {
  deleteCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
};

export type CreateUserMutation = {
  createUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
};

export type UpdateUserMutation = {
  updateUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
};

export type DeleteUserMutation = {
  deleteUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type CreateReportMutationVariables = {
  input: CreateReportInput,
};

export type CreateReportMutation = {
  createReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type UpdateReportMutationVariables = {
  input: UpdateReportInput,
};

export type UpdateReportMutation = {
  updateReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type DeleteReportMutationVariables = {
  input: DeleteReportInput,
};

export type DeleteReportMutation = {
  deleteReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type CreateReigonMutationVariables = {
  input: CreateReigonInput,
};

export type CreateReigonMutation = {
  createReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type UpdateReigonMutationVariables = {
  input: UpdateReigonInput,
};

export type UpdateReigonMutation = {
  updateReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type DeleteReigonMutationVariables = {
  input: DeleteReigonInput,
};

export type DeleteReigonMutation = {
  deleteReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CreateTagMutationVariables = {
  input: CreateTagInput,
};

export type CreateTagMutation = {
  createTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type UpdateTagMutationVariables = {
  input: UpdateTagInput,
};

export type UpdateTagMutation = {
  updateTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type DeleteTagMutationVariables = {
  input: DeleteTagInput,
};

export type DeleteTagMutation = {
  deleteTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CreateCategoryMutationVariables = {
  input: CreateCategoryInput,
};

export type CreateCategoryMutation = {
  createCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type UpdateCategoryMutationVariables = {
  input: UpdateCategoryInput,
};

export type UpdateCategoryMutation = {
  updateCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type DeleteCategoryMutationVariables = {
  input: DeleteCategoryInput,
};

export type DeleteCategoryMutation = {
  deleteCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CreateVoucherMutationVariables = {
  input: CreateVoucherInput,
};

export type CreateVoucherMutation = {
  createVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type UpdateVoucherMutationVariables = {
  input: UpdateVoucherInput,
};

export type UpdateVoucherMutation = {
  updateVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type DeleteVoucherMutationVariables = {
  input: DeleteVoucherInput,
};

export type DeleteVoucherMutation = {
  deleteVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CreateFaqMutationVariables = {
  input: CreateFaqInput,
};

export type CreateFaqMutation = {
  createFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type UpdateFaqMutationVariables = {
  input: UpdateFaqInput,
};

export type UpdateFaqMutation = {
  updateFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type DeleteFaqMutationVariables = {
  input: DeleteFaqInput,
};

export type DeleteFaqMutation = {
  deleteFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type CreateInterestMutationVariables = {
  input: CreateInterestInput,
};

export type CreateInterestMutation = {
  createInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type UpdateInterestMutationVariables = {
  input: UpdateInterestInput,
};

export type UpdateInterestMutation = {
  updateInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type DeleteInterestMutationVariables = {
  input: DeleteInterestInput,
};

export type DeleteInterestMutation = {
  deleteInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
};

export type CreateTransactionMutation = {
  createTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
};

export type UpdateTransactionMutation = {
  updateTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
};

export type DeleteTransactionMutation = {
  deleteTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type CreateCardMutationVariables = {
  input: CreateCardInput,
};

export type CreateCardMutation = {
  createCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type UpdateCardMutationVariables = {
  input: UpdateCardInput,
};

export type UpdateCardMutation = {
  updateCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type DeleteCardMutationVariables = {
  input: DeleteCardInput,
};

export type DeleteCardMutation = {
  deleteCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type CreateCompanyInterestMutationVariables = {
  input: CreateCompanyInterestInput,
};

export type CreateCompanyInterestMutation = {
  createCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateCompanyInterestMutationVariables = {
  input: UpdateCompanyInterestInput,
};

export type UpdateCompanyInterestMutation = {
  updateCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteCompanyInterestMutationVariables = {
  input: DeleteCompanyInterestInput,
};

export type DeleteCompanyInterestMutation = {
  deleteCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateUserCompanyMutationVariables = {
  input: CreateUserCompanyInput,
};

export type CreateUserCompanyMutation = {
  createUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateUserCompanyMutationVariables = {
  input: UpdateUserCompanyInput,
};

export type UpdateUserCompanyMutation = {
  updateUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteUserCompanyMutationVariables = {
  input: DeleteUserCompanyInput,
};

export type DeleteUserCompanyMutation = {
  deleteUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCompanyReportMutationVariables = {
  input: CreateCompanyReportInput,
};

export type CreateCompanyReportMutation = {
  createCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateCompanyReportMutationVariables = {
  input: UpdateCompanyReportInput,
};

export type UpdateCompanyReportMutation = {
  updateCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteCompanyReportMutationVariables = {
  input: DeleteCompanyReportInput,
};

export type DeleteCompanyReportMutation = {
  deleteCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type CreateReportTagMutationVariables = {
  input: CreateReportTagInput,
};

export type CreateReportTagMutation = {
  createReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateReportTagMutationVariables = {
  input: UpdateReportTagInput,
};

export type UpdateReportTagMutation = {
  updateReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteReportTagMutationVariables = {
  input: DeleteReportTagInput,
};

export type DeleteReportTagMutation = {
  deleteReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type CreateReportCategoryMutationVariables = {
  input: CreateReportCategoryInput,
};

export type CreateReportCategoryMutation = {
  createReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateReportCategoryMutationVariables = {
  input: UpdateReportCategoryInput,
};

export type UpdateReportCategoryMutation = {
  updateReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteReportCategoryMutationVariables = {
  input: DeleteReportCategoryInput,
};

export type DeleteReportCategoryMutation = {
  deleteReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type CreateReportReigonMutationVariables = {
  input: CreateReportReigonInput,
};

export type CreateReportReigonMutation = {
  createReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateReportReigonMutationVariables = {
  input: UpdateReportReigonInput,
};

export type UpdateReportReigonMutation = {
  updateReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteReportReigonMutationVariables = {
  input: DeleteReportReigonInput,
};

export type DeleteReportReigonMutation = {
  deleteReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type CreateReportVoucherMutationVariables = {
  input: CreateReportVoucherInput,
};

export type CreateReportVoucherMutation = {
  createReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateReportVoucherMutationVariables = {
  input: UpdateReportVoucherInput,
};

export type UpdateReportVoucherMutation = {
  updateReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteReportVoucherMutationVariables = {
  input: DeleteReportVoucherInput,
};

export type DeleteReportVoucherMutation = {
  deleteReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type GetTaskQueryVariables = {
  id: string,
};

export type GetTaskQuery = {
  getTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type ListTasksQueryVariables = {
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTasksQuery = {
  listTasks:  {
    __typename: "ModelTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      title: string,
      description: string | null,
      status: string | null,
      assignedTo:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
};

export type GetCompanyQuery = {
  getCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type ListCompanysQueryVariables = {
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanysQuery = {
  listCompanys:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportQueryVariables = {
  id: string,
};

export type GetReportQuery = {
  getReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type ListReportsQueryVariables = {
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportsQuery = {
  listReports:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReigonQueryVariables = {
  id: string,
};

export type GetReigonQuery = {
  getReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type ListReigonsQueryVariables = {
  filter?: ModelReigonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReigonsQuery = {
  listReigons:  {
    __typename: "ModelReigonConnection",
    items:  Array< {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetTagQueryVariables = {
  id: string,
};

export type GetTagQuery = {
  getTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type ListTagsQueryVariables = {
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTagsQuery = {
  listTags:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetCategoryQueryVariables = {
  id: string,
};

export type GetCategoryQuery = {
  getCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type ListCategorysQueryVariables = {
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategorysQuery = {
  listCategorys:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetVoucherQueryVariables = {
  id: string,
};

export type GetVoucherQuery = {
  getVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type ListVouchersQueryVariables = {
  filter?: ModelVoucherFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVouchersQuery = {
  listVouchers:  {
    __typename: "ModelVoucherConnection",
    items:  Array< {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetFaqQueryVariables = {
  id: string,
};

export type GetFaqQuery = {
  getFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type ListFaqsQueryVariables = {
  filter?: ModelFaqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFaqsQuery = {
  listFaqs:  {
    __typename: "ModelFaqConnection",
    items:  Array< {
      __typename: "Faq",
      id: string,
      title: string | null,
      question: string | null,
      answer: string | null,
      topic: FaqTopic | null,
      category: FaqCategory | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetInterestQueryVariables = {
  id: string,
};

export type GetInterestQuery = {
  getInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type ListInterestsQueryVariables = {
  filter?: ModelInterestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInterestsQuery = {
  listInterests:  {
    __typename: "ModelInterestConnection",
    items:  Array< {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type ListTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsQuery = {
  listTransactions:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetCardQueryVariables = {
  id: string,
};

export type GetCardQuery = {
  getCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type ListCardsQueryVariables = {
  filter?: ModelCardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCardsQuery = {
  listCards:  {
    __typename: "ModelCardConnection",
    items:  Array< {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetCompanyInterestQueryVariables = {
  id: string,
};

export type GetCompanyInterestQuery = {
  getCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListCompanyInterestsQueryVariables = {
  filter?: ModelCompanyInterestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyInterestsQuery = {
  listCompanyInterests:  {
    __typename: "ModelCompanyInterestConnection",
    items:  Array< {
      __typename: "CompanyInterest",
      id: string,
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
      interests:  {
        __typename: "Interest",
        id: string,
        name: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetUserCompanyQueryVariables = {
  id: string,
};

export type GetUserCompanyQuery = {
  getUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type ListUserCompanysQueryVariables = {
  filter?: ModelUserCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserCompanysQuery = {
  listUserCompanys:  {
    __typename: "ModelUserCompanyConnection",
    items:  Array< {
      __typename: "UserCompany",
      id: string,
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
      user:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetCompanyReportQueryVariables = {
  id: string,
};

export type GetCompanyReportQuery = {
  getCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListCompanyReportsQueryVariables = {
  filter?: ModelCompanyReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyReportsQuery = {
  listCompanyReports:  {
    __typename: "ModelCompanyReportConnection",
    items:  Array< {
      __typename: "CompanyReport",
      id: string,
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      } | null,
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportTagQueryVariables = {
  id: string,
};

export type GetReportTagQuery = {
  getReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListReportTagsQueryVariables = {
  filter?: ModelReportTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportTagsQuery = {
  listReportTags:  {
    __typename: "ModelReportTagConnection",
    items:  Array< {
      __typename: "ReportTag",
      id: string,
      tag:  {
        __typename: "Tag",
        id: string,
        name: string | null,
      } | null,
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportCategoryQueryVariables = {
  id: string,
};

export type GetReportCategoryQuery = {
  getReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListReportCategorysQueryVariables = {
  filter?: ModelReportCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportCategorysQuery = {
  listReportCategorys:  {
    __typename: "ModelReportCategoryConnection",
    items:  Array< {
      __typename: "ReportCategory",
      id: string,
      category:  {
        __typename: "Category",
        id: string,
        name: string | null,
      } | null,
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportReigonQueryVariables = {
  id: string,
};

export type GetReportReigonQuery = {
  getReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListReportReigonsQueryVariables = {
  filter?: ModelReportReigonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportReigonsQuery = {
  listReportReigons:  {
    __typename: "ModelReportReigonConnection",
    items:  Array< {
      __typename: "ReportReigon",
      id: string,
      reigon:  {
        __typename: "Reigon",
        id: string,
        name: string | null,
      } | null,
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type GetReportVoucherQueryVariables = {
  id: string,
};

export type GetReportVoucherQuery = {
  getReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type ListReportVouchersQueryVariables = {
  filter?: ModelReportVoucherFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportVouchersQuery = {
  listReportVouchers:  {
    __typename: "ModelReportVoucherConnection",
    items:  Array< {
      __typename: "ReportVoucher",
      id: string,
      voucher:  {
        __typename: "Voucher",
        id: string,
        name: string | null,
        code: string | null,
        discountPercentage: string | null,
      } | null,
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      } | null,
    } | null > | null,
    nextToken: string | null,
  } | null,
};

export type OnCreateTaskSubscription = {
  onCreateTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateTaskSubscription = {
  onUpdateTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteTaskSubscription = {
  onDeleteTask:  {
    __typename: "Task",
    id: string,
    title: string,
    description: string | null,
    status: string | null,
    assignedTo:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCompanySubscription = {
  onCreateCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnUpdateCompanySubscription = {
  onUpdateCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnDeleteCompanySubscription = {
  onDeleteCompany:  {
    __typename: "Company",
    id: string,
    createdAt: string,
    name: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    address: string | null,
    province: Province | null,
    industry: Industry | null,
    physicalAddress: string | null,
    numberOfEmployees: string | null,
    archived: boolean | null,
    interests:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    suburb: Suburb | null,
    teamLead:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
    teamMembers:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reports:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnCreateUserSubscription = {
  onCreateUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser:  {
    __typename: "User",
    id: string,
    dateOfBirth: string | null,
    name: string | null,
    surname: string | null,
    emailAddress: string | null,
    contactNumber: string | null,
    idNumber: string | null,
    physicalAddress: string | null,
    archived: boolean | null,
    verified: boolean | null,
    role: UserRole | null,
    status: UserStatus | null,
    jobTitle: string | null,
    company:  {
      __typename: "ModelUserCompanyConnection",
      items:  Array< {
        __typename: "UserCompany",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companyTeamLead:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateReportSubscription = {
  onCreateReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnUpdateReportSubscription = {
  onUpdateReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnDeleteReportSubscription = {
  onDeleteReport:  {
    __typename: "Report",
    id: string,
    name: string | null,
    description: string | null,
    publisedDate: string | null,
    price: string | null,
    documentLocation: string | null,
    maxDownloads: string | null,
    downloadable: boolean | null,
    status: ReportStatus | null,
    province: Province | null,
    suburb: Suburb | null,
    city: string | null,
    paidOrFree: boolean | null,
    reportDetails: string | null,
    coverImageUrl: string | null,
    documentResourceUrl: string | null,
    tags:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    categories:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    reigon:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    companys:  {
      __typename: "ModelCompanyReportConnection",
      items:  Array< {
        __typename: "CompanyReport",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    vouchers:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
    transactions:  {
      __typename: "Transaction",
      id: string,
      card:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
      report:  {
        __typename: "Report",
        id: string,
        name: string | null,
        description: string | null,
        publisedDate: string | null,
        price: string | null,
        documentLocation: string | null,
        maxDownloads: string | null,
        downloadable: boolean | null,
        status: ReportStatus | null,
        province: Province | null,
        suburb: Suburb | null,
        city: string | null,
        paidOrFree: boolean | null,
        reportDetails: string | null,
        coverImageUrl: string | null,
        documentResourceUrl: string | null,
      },
      company:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      },
    } | null,
  } | null,
};

export type OnCreateReigonSubscription = {
  onCreateReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnUpdateReigonSubscription = {
  onUpdateReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnDeleteReigonSubscription = {
  onDeleteReigon:  {
    __typename: "Reigon",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportReigonConnection",
      items:  Array< {
        __typename: "ReportReigon",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnCreateTagSubscription = {
  onCreateTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnUpdateTagSubscription = {
  onUpdateTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnDeleteTagSubscription = {
  onDeleteTag:  {
    __typename: "Tag",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportTagConnection",
      items:  Array< {
        __typename: "ReportTag",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnCreateCategorySubscription = {
  onCreateCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnUpdateCategorySubscription = {
  onUpdateCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnDeleteCategorySubscription = {
  onDeleteCategory:  {
    __typename: "Category",
    id: string,
    name: string | null,
    reports:  {
      __typename: "ModelReportCategoryConnection",
      items:  Array< {
        __typename: "ReportCategory",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnCreateVoucherSubscription = {
  onCreateVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnUpdateVoucherSubscription = {
  onUpdateVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnDeleteVoucherSubscription = {
  onDeleteVoucher:  {
    __typename: "Voucher",
    id: string,
    name: string | null,
    code: string | null,
    discountPercentage: string | null,
    reports:  {
      __typename: "ModelReportVoucherConnection",
      items:  Array< {
        __typename: "ReportVoucher",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnCreateFaqSubscription = {
  onCreateFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type OnUpdateFaqSubscription = {
  onUpdateFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type OnDeleteFaqSubscription = {
  onDeleteFaq:  {
    __typename: "Faq",
    id: string,
    title: string | null,
    question: string | null,
    answer: string | null,
    topic: FaqTopic | null,
    category: FaqCategory | null,
  } | null,
};

export type OnCreateInterestSubscription = {
  onCreateInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnUpdateInterestSubscription = {
  onUpdateInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnDeleteInterestSubscription = {
  onDeleteInterest:  {
    __typename: "Interest",
    id: string,
    name: string | null,
    company:  {
      __typename: "ModelCompanyInterestConnection",
      items:  Array< {
        __typename: "CompanyInterest",
        id: string,
      } | null > | null,
      nextToken: string | null,
    } | null,
  } | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction:  {
    __typename: "Transaction",
    id: string,
    card:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    },
  } | null,
};

export type OnCreateCardSubscription = {
  onCreateCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type OnUpdateCardSubscription = {
  onUpdateCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type OnDeleteCardSubscription = {
  onDeleteCard:  {
    __typename: "Card",
    id: string,
    name: string | null,
    type: CardType | null,
    number: string | null,
    nameOnCard: string | null,
    expiryDate: string | null,
    ccv: string | null,
    purchases:  {
      __typename: "Card",
      id: string,
      name: string | null,
      type: CardType | null,
      number: string | null,
      nameOnCard: string | null,
      expiryDate: string | null,
      ccv: string | null,
      purchases:  {
        __typename: "Card",
        id: string,
        name: string | null,
        type: CardType | null,
        number: string | null,
        nameOnCard: string | null,
        expiryDate: string | null,
        ccv: string | null,
      },
    },
  } | null,
};

export type OnCreateCompanyInterestSubscription = {
  onCreateCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateCompanyInterestSubscription = {
  onUpdateCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteCompanyInterestSubscription = {
  onDeleteCompanyInterest:  {
    __typename: "CompanyInterest",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    interests:  {
      __typename: "Interest",
      id: string,
      name: string | null,
      company:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateUserCompanySubscription = {
  onCreateUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateUserCompanySubscription = {
  onUpdateUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteUserCompanySubscription = {
  onDeleteUserCompany:  {
    __typename: "UserCompany",
    id: string,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    user:  {
      __typename: "User",
      id: string,
      dateOfBirth: string | null,
      name: string | null,
      surname: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      idNumber: string | null,
      physicalAddress: string | null,
      archived: boolean | null,
      verified: boolean | null,
      role: UserRole | null,
      status: UserStatus | null,
      jobTitle: string | null,
      company:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      companyTeamLead:  {
        __typename: "Company",
        id: string,
        createdAt: string,
        name: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        address: string | null,
        province: Province | null,
        industry: Industry | null,
        physicalAddress: string | null,
        numberOfEmployees: string | null,
        archived: boolean | null,
        suburb: Suburb | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCompanyReportSubscription = {
  onCreateCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateCompanyReportSubscription = {
  onUpdateCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteCompanyReportSubscription = {
  onDeleteCompanyReport:  {
    __typename: "CompanyReport",
    id: string,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
    company:  {
      __typename: "Company",
      id: string,
      createdAt: string,
      name: string | null,
      emailAddress: string | null,
      contactNumber: string | null,
      address: string | null,
      province: Province | null,
      industry: Industry | null,
      physicalAddress: string | null,
      numberOfEmployees: string | null,
      archived: boolean | null,
      interests:  {
        __typename: "ModelCompanyInterestConnection",
        nextToken: string | null,
      } | null,
      suburb: Suburb | null,
      teamLead:  {
        __typename: "User",
        id: string,
        dateOfBirth: string | null,
        name: string | null,
        surname: string | null,
        emailAddress: string | null,
        contactNumber: string | null,
        idNumber: string | null,
        physicalAddress: string | null,
        archived: boolean | null,
        verified: boolean | null,
        role: UserRole | null,
        status: UserStatus | null,
        jobTitle: string | null,
      } | null,
      teamMembers:  {
        __typename: "ModelUserCompanyConnection",
        nextToken: string | null,
      } | null,
      reports:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateReportTagSubscription = {
  onCreateReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateReportTagSubscription = {
  onUpdateReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteReportTagSubscription = {
  onDeleteReportTag:  {
    __typename: "ReportTag",
    id: string,
    tag:  {
      __typename: "Tag",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateReportCategorySubscription = {
  onCreateReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateReportCategorySubscription = {
  onUpdateReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteReportCategorySubscription = {
  onDeleteReportCategory:  {
    __typename: "ReportCategory",
    id: string,
    category:  {
      __typename: "Category",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateReportReigonSubscription = {
  onCreateReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateReportReigonSubscription = {
  onUpdateReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteReportReigonSubscription = {
  onDeleteReportReigon:  {
    __typename: "ReportReigon",
    id: string,
    reigon:  {
      __typename: "Reigon",
      id: string,
      name: string | null,
      reports:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateReportVoucherSubscription = {
  onCreateReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateReportVoucherSubscription = {
  onUpdateReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteReportVoucherSubscription = {
  onDeleteReportVoucher:  {
    __typename: "ReportVoucher",
    id: string,
    voucher:  {
      __typename: "Voucher",
      id: string,
      name: string | null,
      code: string | null,
      discountPercentage: string | null,
      reports:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
    } | null,
    report:  {
      __typename: "Report",
      id: string,
      name: string | null,
      description: string | null,
      publisedDate: string | null,
      price: string | null,
      documentLocation: string | null,
      maxDownloads: string | null,
      downloadable: boolean | null,
      status: ReportStatus | null,
      province: Province | null,
      suburb: Suburb | null,
      city: string | null,
      paidOrFree: boolean | null,
      reportDetails: string | null,
      coverImageUrl: string | null,
      documentResourceUrl: string | null,
      tags:  {
        __typename: "ModelReportTagConnection",
        nextToken: string | null,
      } | null,
      categories:  {
        __typename: "ModelReportCategoryConnection",
        nextToken: string | null,
      } | null,
      reigon:  {
        __typename: "ModelReportReigonConnection",
        nextToken: string | null,
      } | null,
      companys:  {
        __typename: "ModelCompanyReportConnection",
        nextToken: string | null,
      } | null,
      vouchers:  {
        __typename: "ModelReportVoucherConnection",
        nextToken: string | null,
      } | null,
      transactions:  {
        __typename: "Transaction",
        id: string,
      } | null,
    } | null,
  } | null,
};



// WEBPACK FOOTER //
// ./src/API.ts